"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  setToken: true,
  getToken: true,
  setLegacyToken: true,
  getLegacyToken: true,
  clearToken: true,
  clearLegacyToken: true,
  clearTokens: true
};
Object.defineProperty(exports, "setToken", {
  enumerable: true,
  get: function () {
    return _storage.setToken;
  }
});
Object.defineProperty(exports, "getToken", {
  enumerable: true,
  get: function () {
    return _storage.getToken;
  }
});
Object.defineProperty(exports, "setLegacyToken", {
  enumerable: true,
  get: function () {
    return _storage.setLegacyToken;
  }
});
Object.defineProperty(exports, "getLegacyToken", {
  enumerable: true,
  get: function () {
    return _storage.getLegacyToken;
  }
});
Object.defineProperty(exports, "clearToken", {
  enumerable: true,
  get: function () {
    return _storage.clearToken;
  }
});
Object.defineProperty(exports, "clearLegacyToken", {
  enumerable: true,
  get: function () {
    return _storage.clearLegacyToken;
  }
});
Object.defineProperty(exports, "clearTokens", {
  enumerable: true,
  get: function () {
    return _storage.clearTokens;
  }
});

require("core-js/proposals/promise-any");

var _storage = require("./utils/storage");

var _authenticate = require("./authenticate");

Object.keys(_authenticate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _authenticate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _authenticate[key];
    }
  });
});

var _passwordResets = require("./passwordResets");

Object.keys(_passwordResets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _passwordResets[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _passwordResets[key];
    }
  });
});

var _passwordlessRequest = require("./passwordlessRequest");

Object.keys(_passwordlessRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _passwordlessRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _passwordlessRequest[key];
    }
  });
});

var _accountInformation = require("./accountInformation");

Object.keys(_accountInformation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _accountInformation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _accountInformation[key];
    }
  });
});

var _createAccount = require("./createAccount");

Object.keys(_createAccount).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createAccount[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createAccount[key];
    }
  });
});

var _getAuthUrlToWebsite = require("./getAuthUrlToWebsite");

Object.keys(_getAuthUrlToWebsite).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getAuthUrlToWebsite[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getAuthUrlToWebsite[key];
    }
  });
});

var _authenticationClaim = require("./authenticationClaim");

Object.keys(_authenticationClaim).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _authenticationClaim[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _authenticationClaim[key];
    }
  });
});

var _errors = require("./errors");

Object.keys(_errors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _errors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _errors[key];
    }
  });
});

var _enums = require("./enums");

Object.keys(_enums).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _enums[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _enums[key];
    }
  });
});

var _helpers = require("./utils/helpers");

Object.keys(_helpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _helpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _helpers[key];
    }
  });
});

var _headers = require("./utils/headers");

Object.keys(_headers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _headers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _headers[key];
    }
  });
});

var _config = require("./config");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _config[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _config[key];
    }
  });
});

var _validators = require("./validators");

Object.keys(_validators).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validators[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validators[key];
    }
  });
});